var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.47,17 L17.53,17 C19.07,17 20.03,15.33 19.26,14 L11.73,0.99 C10.96,-0.34 9.04,-0.34 8.27,0.99 L0.74,14 C-0.03,15.33 0.93,17 2.47,17 Z M10,10 C9.45,10 9,9.55 9,9 L9,7 C9,6.45 9.45,6 10,6 C10.55,6 11,6.45 11,7 L11,9 C11,9.55 10.55,10 10,10 Z M11,14 L9,14 L9,12 L11,12 L11,14 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningWhite);
export default __webpack_public_path__ + "static/media/warning-white.f5152b9fa6aa342297e3a55e56042f84.svg";
export { ForwardRef as ReactComponent };